import { name as appName } from '../package.json';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

export const CLOUDINARY_NAME = process.env.REACT_APP_CLOUDINARY_NAME || '';
export const CLOUDINARY_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET || '';

export const AUTH0_API = {
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  issuer: process.env.REACT_APP_AUTH0_ISSUER,
};

export const APP_NAME = process.env.REACT_APP_NAME || appName;

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;

export const ACTIVE_YEAR = parseInt(process.env.REACT_APP_ACTIVE_YEAR, 10);

export const GOOGLE_ANALYTICS_API = process.env.REACT_APP_GA_MEASUREMENT_ID;

// LAYOUT
// ----------------------------------------------------------------------

export const DRAWER_WIDTH = 260;

export const DASHBOARD_HEADER_MOBILE = 64;
export const DASHBOARD_HEADER_DESKTOP = 92;
export const DASHBOARD_NAVBAR_WIDTH = 280;
export const DASHBOARD_NAVBAR_COLLAPSE_WIDTH = 88;

export const DASHBOARD_NAVBAR_ROOT_ITEM_HEIGHT = 48;
export const DASHBOARD_NAVBAR_SUB_ITEM_HEIGHT = 40;
export const DASHBOARD_NAVBAR_ICON_ITEM_SIZE = 22;

export const MAIN_HEADER_DESKTOP = 88;
export const MAIN_HEADER_MOBILE = 64;

// SETTINGS
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeStretch: false,
};
